module.exports = __webpack_public_path__ + "static/media/image31.4c7940e8.jpg";